import { Link } from "react-router-dom";
import { Cpu, ShoppingBag, HeartPulse, Landmark, GraduationCap, Building2, UtensilsCrossed, Briefcase, ArrowRight } from "lucide-react";
import { useSeo } from "@/lib/useSeo";
import { Reveal, SectionHead } from "@/components/site/Reveal";
import { Button } from "@/components/ui/button";

const INDUSTRIES = [
  { icon: Cpu, name: "SaaS & Startups", desc: "MVPs, dashboards and scalable platforms." },
  { icon: ShoppingBag, name: "E-commerce & Retail", desc: "Storefronts that convert and scale." },
  { icon: HeartPulse, name: "Healthcare", desc: "Secure, accessible digital experiences." },
  { icon: Landmark, name: "Finance & Fintech", desc: "Trustworthy, data-rich applications." },
  { icon: GraduationCap, name: "Education", desc: "Engaging learning platforms and portals." },
  { icon: Building2, name: "Real Estate", desc: "Listings, portals and lead generation." },
  { icon: UtensilsCrossed, name: "Hospitality", desc: "Booking-ready sites and brand experiences." },
  { icon: Briefcase, name: "Professional Services", desc: "Authority-building sites and automation." },
];

export default function Industries() {
  useSeo({ title: "Industries", description: "Buddy Solution serves SaaS, e-commerce, healthcare, finance, education and more, worldwide." });
  return (
    <div className="bs-container py-16 lg:py-20">
      <Reveal><SectionHead center eyebrow="Industries" title="Experience across sectors"
        subtitle="We adapt our approach to the realities of your industry, worldwide." /></Reveal>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {INDUSTRIES.map((ind, i) => (
          <Reveal key={ind.name} delay={i * 0.04}>
            <div className="h-full bs-card p-6 hover:-translate-y-1 hover:border-primary/50">
              <div className="mb-3 inline-flex rounded-xl bg-accent/12 p-2.5 text-accent"><ind.icon className="h-5 w-5" /></div>
              <h3 className="font-display text-base font-bold">{ind.name}</h3>
              <p className="mt-1.5 text-sm text-muted-foreground">{ind.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="mt-14 text-center">
        <Button asChild className="rounded-full"><Link to="/contact">Discuss your industry <ArrowRight className="ml-2 h-4 w-4" /></Link></Button>
      </div>
    </div>
  );
}
